import { WalletTabType } from "../myWallet/components/WalletTabType"

export enum LatestNewsPopupSceneResult {
    DEFAULT = 'DEFAULT',
    MY_WALLET = 'MY_WALLET',
    GOLDEN_WHEEL = 'GOLDEN_WHEEL'
}

export type LatestNewsResultOptions<T extends LatestNewsPopupSceneResult> = {
    type: T,
    args: T extends LatestNewsPopupSceneResult.MY_WALLET ? WalletTabType : unknown;
}